import { render, staticRenderFns } from "./expertExtraction.vue?vue&type=template&id=79b90ca0&scoped=true"
import script from "./expertExtraction.vue?vue&type=script&lang=js"
export * from "./expertExtraction.vue?vue&type=script&lang=js"
import style0 from "./expertExtraction.vue?vue&type=style&index=0&id=79b90ca0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b90ca0",
  null
  
)

export default component.exports